function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("defs", null);

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Components",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Forms",
  transform: "translate(-2362.000000, -1763.000000)",
  stroke: "#323E48"
}, /*#__PURE__*/React.createElement("g", {
  id: "Assets",
  transform: "translate(2361.000000, 1223.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon_pillbox_close",
  transform: "translate(0.000000, 513.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "close",
  transform: "translate(2.000000, 27.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.233345,0.2333345 L6.76667822,6.76666772",
  id: "Stroke-6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.76667822,0.2333345 L0.233345,6.76666772",
  id: "Stroke-7"
}))))));

function SvgIconPillboxClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "7px",
    viewBox: "0 0 9 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "close") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPillboxClose);
export default __webpack_public_path__ + "static/media/icon_pillbox_close.c2fb55b1.svg";
export { ForwardRef as ReactComponent };